import * as Dtos from '../dtos/Tmd.dtos';

export function getLabelForItemComponentPrimitive(
    collectionItemComponentOverrides: Dtos.CollectionItemComponentOverride[],
    collectionItemComponent: Dtos.CollectionItemComponent,
    itemComponentPrimitive: Dtos.ItemComponentPrimitive
): string {
    if (collectionItemComponentOverrides && collectionItemComponent && itemComponentPrimitive) {
        const override = collectionItemComponentOverrides.find(f => f.collectionItemComponentId == collectionItemComponent.id && f.itemComponentPrimitiveId == itemComponentPrimitive.id);

        if (override) {
            itemComponentPrimitive.label = override.label;
        }
    }
    return itemComponentPrimitive.label;
}


export function getInstructionsForItemComponentPrimitive(
    collectionItemComponentOverrides: Dtos.CollectionItemComponentOverride[],
    collectionItemComponent: Dtos.CollectionItemComponent,
    itemComponentPrimitive: Dtos.ItemComponentPrimitive
): string {
    let instructions: string = "";
    if (collectionItemComponentOverrides && collectionItemComponent && itemComponentPrimitive) {
        const override = collectionItemComponentOverrides.find(f => f.collectionItemComponentId == collectionItemComponent.id && f.itemComponentPrimitiveId == itemComponentPrimitive.id)
        if (override) {
            instructions = override.instructions;
        }
    }
    return instructions;
}